'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { isAnalyticsEnabled } from '@/lib/analytics';

/**
 * Plausible's `manual` mode requires us to fire `pageview` on route changes
 * (App Router doesn't reload the script between navigations).
 *
 * Wrapped in <Suspense> at the export site because `useSearchParams` requires
 * it under Next 16.
 */
function Tracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    try {
      window.plausible!('pageview');
    } catch {
      // never throw from analytics
    }
  }, [pathname, searchParams]);

  return null;
}

export default function RouteChangeTracker() {
  return (
    <Suspense fallback={null}>
      <Tracker />
    </Suspense>
  );
}
